import { MNHNError } from '@/domain/MNHNError';

export class NotFound extends MNHNError {
  constructor(item: string) {
    super(`"${item}" was not found!`);
  }
}
